import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {MatChipsModule} from '@angular/material/chips';
import {SharedModule} from '../../shared/modules/shared.module';
import {SearchPageRoutingModule} from './search-page-routing.module';
import {SearchPageComponent} from './search-page.component';

@NgModule({
  declarations: [SearchPageComponent],
  imports: [
    CommonModule,
    SearchPageRoutingModule,
    SharedModule,
    MatChipsModule
  ]
})

export class SearchPageModule {
}
